import { render, staticRenderFns } from "./theme_collection_details.vue?vue&type=template&id=671d170d&scoped=true&"
import script from "./theme_collection_details.vue?vue&type=script&lang=js&"
export * from "./theme_collection_details.vue?vue&type=script&lang=js&"
import style0 from "./theme_collection_details.vue?vue&type=style&index=0&id=671d170d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d170d",
  null
  
)

export default component.exports